import { render, staticRenderFns } from "./report-pulse.vue?vue&type=template&id=6b032a82&scoped=true&"
import script from "./report-pulse.vue?vue&type=script&lang=ts&"
export * from "./report-pulse.vue?vue&type=script&lang=ts&"
import style0 from "./report-pulse.vue?vue&type=style&index=0&id=6b032a82&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b032a82",
  null
  
)

export default component.exports